import { render, staticRenderFns } from "./CountedServicesTabs.vue?vue&type=template&id=48e451bd&"
import script from "./CountedServicesTabs.vue?vue&type=script&lang=js&"
export * from "./CountedServicesTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports